module.exports = __webpack_public_path__ + "static/media/hair5.4b58866f.png";